import { createNextTableContext } from '@core/table';

export const BranchesTableContext = createNextTableContext();
